import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { TranslateService as Translate } from '@ngx-translate/core';
import { en_US, ja_JP, zh_TW, NzI18nService, zh_CN } from 'ng-zorro-antd/i18n';
import ja from '@angular/common/locales/ja';
import tw from '@angular/common/locales/twq';
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { StoreService } from './store.service';
import { log } from '@root/util/logger';
export enum Lang {
  ZH = 0,
  TW = 1,
  EN = 2,
  JP = 3
}

export enum LangString {
  ZH = 'cn',
  TW = 'tw',
  EN = 'en',
  JP = 'jp',
}

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  private __tasks = [];
  constructor(
    private storeService: StoreService,
    private translate: Translate,
    private zorroI18nService: NzI18nService
  ) {
  }

  /** 
   * 语言选取的优先级
   * 1，首先根据域名判断
   *     国际版
   *       - ① getStoreLang
   *       - ② EN
   *     国内版
   *       - ZH
   * 
   * 2，其次根据接口判断
   */

  getCurrentLang(): LangString {
    return  this.translate.currentLang as LangString;
  }

  get(key, params?): Observable<string> {
    return this.translate.get(key, params);
  }

  /** @alias syncGet */
  t (key, params?): string {
    return this.syncGet(key, params);
  }

  syncGet(key, params?): string {
    return this.translate.instant(key, params);
  }

  onLangChange() {
    return this.translate.onLangChange;
  }

  getSystemLang(): Lang {
    // const store = parseInt(this.storeService.get('hostex_locale_lang', 2));
    // console.log('store: ', store)
    // if (!_.isNaN(store)) {
    //   return store;
    // }
    const lang = _.toLower(this.translate.getBrowserCultureLang());
    if (lang === 'zh-tw') {
      return Lang.TW;
    } else if (lang === 'ja') {
      return Lang.JP;
    } else if (_.startsWith(lang, 'zh')) {
      return Lang.ZH;
    } else {
      return Lang.EN;
    }
  }

  getStoreLang (): Lang | null {
    const store = parseInt(this.storeService.get('hostex_locale_lang', 2));
    if (!_.isNaN(store)) {
      return store;
    }
    return null;
  }

  setCurrentLang(id: Lang) {
    // console.log('%cStart set language: ', 'font-weight: 900; color: #2c80f0;', id);
    this.registerLocaleData(id);
    this.registerBaseLocaleData(id);
    this.registerAntdLocaleData(id);
    this.storeService.set('hostex_locale_lang', id, 2);
  }

  /** 内部管道需要的国际化数据 */
  private registerBaseLocaleData(id: Lang) {
    const localeMap = { 0: zh, 1: tw, 2: en, 3: ja };
    registerLocaleData(localeMap[id]);
  }

  /** 
   * 主要业务翻译需要的数据
   * 
   * translate.use返回的是一个Observable
   * 这在某种网络情况下连续调用两次该方法可能会导致Observable的完成顺序不同，从而导致最终的翻译语言不准
   * 这里使用队列解决这个问题，：
   * 所有的任务直接推入队列，
   *  如果当前有正在执行的任务，则直接进入队列
   *  如果没有正在执行的任务，从队列中取出第一个开始执行，执行完毕后触发下一个任务
   * */
  private registerLocaleData(id?: Lang) {
    const map = { 0: 'cn', 1: 'tw', 2: 'en', 3: 'jp' };
    const lang = map[id];

    const task = () => {
      log(`Task (set language ${lang}) Start`);
      const loading = this.translate.use(lang);
      loading.subscribe(r => {
        log(`Task (set language ${lang}) Over`);
        this.__tasks.shift();

        const next = this.__tasks[0];
        if (next) {
          next();
        }
      });
    }

    this.__tasks.push(task);

    if (this.__tasks.length === 1) {
      log('Task list is empty, start executing ... ');
      task();
    } else {
      log('Task list is executing another task, waiting ... ');
    }
  }

  /** antd库翻译需要的数据 */
  private registerAntdLocaleData(id: Lang) {
    const zorroMap = { 0: zh_CN, 1: zh_TW, 2: en_US, 3: ja_JP };
    this.zorroI18nService.setLocale(zorroMap[id]);
  }

}
